const appendPaymentForm = data => {
  const paymentForm = document.createElement('form')

  paymentForm.setAttribute('method', 'post')
  paymentForm.setAttribute('action', data.bank_url)
  paymentForm.setAttribute('style', 'position: absolute; left: 0; bottom: 0; width: 0px; height: 0px; visibility: hidden;')

  for (let field in data.payment_payload) {
    const input = document.createElement('input')
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', field)
    input.setAttribute('value', data.payment_payload[field])

    paymentForm.append(input)
  }

  document.querySelector('body').append(paymentForm)

  return paymentForm
}

const redirectToBank = order => {
  const paymentForm = appendPaymentForm(order)
  paymentForm.submit()
}


export { appendPaymentForm, redirectToBank }
